import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gouxuan",
  "use": "icon-gouxuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gouxuan\"><path d=\"M64.132646 496.564449l57.085136-54.933123L383.858528 664.712077c0 0 195.159842-180.534749 552.393989-479.748459l23.016203 57.541531c0 0-297.774941 287.705608-576.84896 594.112136L64.132646 496.564449z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol